var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-container"},[_c('img',{ref:"image",attrs:{"src":_vm.src,"height":"320px","width":"320px","crossorigin":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }